// Actions constants
export const GET_STATUS_TASK = 'GET_STATUS_TASK'
export const START_DOWNLOAD = 'START_DOWNLOAD'
export const ESTIMATE_SIZE = 'ESTIMATE_SIZE'
export const BUILD_SITE_MAP = 'BUILD_SITE_MAP'
export const GET_ZIP = 'GET_ZIP'
export const GET_SIZE = 'GET_SIZE'
export const GET_SITE_MAP = 'GET_SITE_MAP'
export const ENG = 'ENG'
export const RUS = 'RUS'

// Button titles constans
export const COPY = 'COPY'
export const CLOSE = 'CLOSE'

// OneTimeInfoHeaderType constants
export const ONE_TIME_INFO_TASK_HEADER = 'oneTimeInfoTaskHeader'
export const ONE_TIME_INFO_SIZE_HEADER = 'oneTimeInfoSizeHeader'
export const ONE_TIME_INFO_STATUS_HEADER = 'oneTimeInfoStatusHeader'
export const ONE_TIME_INFO_ERROR_HEADER = 'oneTimeInfoErrorHeader'
export const ONE_TIME_INFO_DOWNLOAD_HEADER = 'oneTimeInfoDownloadHeader'
export const ONE_TIME_INFO_BODY_MOCK = 'oneTimeInfoBodyMock'

// LocalStorage constants
export const RECENTLY_VALUES = 'recently_values';
export const RECENTLY_VALUES_LENGTH = 100;
